import React, { useEffect, useState } from "react";
import FormRender from "../../components/FormRender";
import { Add, CopyAllOutlined, Delete } from "@mui/icons-material";
import { v4 as uuid } from "uuid";
import useAxiosInstance from "../../hooks/useAxios";
import { toast } from "react-toastify";
import { TableCustom } from "../../components/Table";
import { FaSpinner } from "react-icons/fa";

const isValidEmail = (input) => {
	const validRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,15})+$/;

	return input?.match(validRegex);
};

const Card = ({ setDummy, id }) => {
  const [formData, setFormData] = useState({})
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState([]);
  const axiosInstance = useAxiosInstance();

  return <div><div className="flex items-end gap-x-2 w-full">
    <div className="grid grid-cols-3 gap-x-2 w-full">
      <FormRender
        formData={formData}
        formSettings={[
          {
            label: "Report IDs(Comma Sep)",
            type: "text",
            saveKey: "report_ids"
          },
          {
            label: "username",
            type: "text",
            saveKey: "username"
          },
          {
            label: "Count credits",
            type: "select",
            options: [{ value: false, label: "False" }, { value: true, label: "True" }],
            saveKey: "count_credits"
          },
        ]}
        setFormData={setFormData}
      />
    </div>

    <button
      disabled={loading}
      onClick={() => {
        setDummy(prev => prev.filter(item => item !== id))
      }}
      className="p-2 border disabled:bg-white disabled:text-black rounded-lg h-full bg-black text-white"><Delete /></button>

    <button
      disabled={loading}
      onClick={() => {
        if (!formData.report_ids) {
          toast.info("Please enter Report IDs.");
          return;
        }
        if (!formData.username) {
          toast.info("Please enter username.");
          return;
        }
        if (!isValidEmail(formData.username)) {
          toast.info("Please enter a valid username.");
          return;
        }

        setResponse([])
        setLoading(true)
        axiosInstance
          .post("/accounts/bulk_report_copy/", {
            ...formData, count_credits: formData.count_credits === "true" ? true : false
          })
          .then((res) => {
            setLoading(false);
            let newArray = []
            res?.data?.data?.forEach(it => {
              newArray.push({ ...it, id: it.output })
            })
            setResponse(newArray);
            if (res.data.status === "success") {
              toast.success(res.data.message);
            } else {
              toast.info(res.data.message);
            }
          })
          .catch((err) => {
            setLoading(false);
            console.log(err?.response?.data?.message);
          });
      }}
      className="p-2 border rounded-lg flex gap-x-1 items-center h-full bg-black text-white">{loading ? "Loading..." : <>Start <CopyAllOutlined /></>}</button>

  </div>
    {response.length !== 0 ?
      <div className="border rounded-xl mt-3">
        <div className={`overflow-x-auto bg-slate-100 mt-4 j-[90vh] max-h-[90vh] rounded-xl`}>
          <table className="w-full relative bg-slate-50 ">
            <thead className="sticky top-0 bg-white">
              <th
                className={`px-2 py-1 text-center`}
              >
                <p className="flex items-center justify-left  text-xm font-medium mx-2 my-1 gap-x-1 text-center">
                  Original Report ID
                </p>
              </th>

              <th
                className={`px-2 py-1 text-center `}
              >
                <p className="flex items-center justify-left  text-xm font-medium mx-2 my-1 gap-x-1 text-center">
                  Link
                </p>
              </th>

              <th

                className={`px-2 py-1 text-center`}
              >
                <p className="flex items-center justify-left  text-xm font-medium mx-2 my-1 gap-x-1 text-center">
                  Status
                </p>
              </th>

            </thead>
            <tbody className="mt-4 divide-y">
              {response.map(rt => {
                return <ReportRowCard key={rt} rt={rt} />
              })}
            </tbody>
          </table>

        </div></div> : null}
  </div>
}


const ReportCopy = () => {
  const [dummy, setDummy] = useState([])

  useEffect(() => {
    if (dummy.length === 0) {
      setDummy([uuid()])
    }
  }, [dummy])

  return (
    <div className="">
      <div className={` w-full justify-center p-5 ${"items-start "} flex`}>
        <div className="w-[900px] p-3 mt-5 border rounded-lg bg-white">
          <div className="flex justify-between items-center"><p className="text-2xl font-semibold mb-4">Bulk Report Copy</p>
            <button
              onClick={() => {
                setDummy(prev => [...prev, uuid()])
              }}
              className="p-2 border rounded-lg h-full bg-black text-white"><Add /></button>
          </div>
          {dummy.map(it => {
            return <Card
              setDummy={setDummy}
              id={it}
              key={it}
            />
          })}
        </div>
      </div>
    </div>
  );
};

export default ReportCopy;


const ReportRowCard = ({ rt }) => {
  const reportId = rt['output'].split('/').pop()
  const [reportStatus, setReportStatus] = useState(false)
  const axiosInstance = useAxiosInstance();

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (reportStatus) {
        clearInterval(intervalId);
        return
      }

      axiosInstance
        .post("/accounts/get_report_active_status/", {
          report_ids: [reportId]
        })
        .then((res) => {
          setReportStatus(res?.data?.data?.[reportId] || false);
        })
    }, 2500);

    return () => {
      clearInterval(intervalId);
    };
  }, [reportId, reportStatus])


  return <tr

    className="p-2 rounded-xl border-b last:border-b-0 odd:bg-slate-100 even:bg-slate-50"
  >
    <td className="px-2 py-1">
      <p className="flex justify-start mx-2 w-full">
        <span className="font-medium text-xs">
          {rt['input']}
        </span>
      </p>
    </td>
    <td className="px-2 py-1">
      <p className="flex justify-start mx-2 w-full">
        <span className="font-medium text-xs">
          {rt['output']}
        </span>
      </p>
    </td>
    <td className="px-2 py-1">
      <p className="flex justify-start mx-2 w-full">
        <span className="font-medium text-xs">
          {!reportStatus ? <div className="animate-spin flex justify-center">
            <FaSpinner />
          </div> : 'Completed'}
        </span>
      </p>
    </td>
  </tr>
}